export const DFP_SETUP = {
    NetworkID: '/21672954868'
};

export const DFP_SIZES = {
    Banner: [ [2560, 290], [970, 90],[728, 90], [468,90] ],
    Block: [ [300, 250], [300, 600] ],
    Desktop: [ [728, 90], [300, 600] ],
    Mobile: [ [ 300, 250] ],
    Default: [ [970, 90], [728, 90], [300, 600], [300, 250] ]
};


export const DFP_VIEWPORT = {
    Desktop: [1024, 768],
    Tablet: [900, 768],
    Mobile: []
};

/* Specific */
// 300x250, 300x600, 468x60, 728x90, 970x90, 970x250, 2560x290

/* Generic */
// 468x60, 728x90, 970x90, 970x250, 2560x290



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/ReactDFPHelper.js